import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const propTypes = {
  className: PropTypes.string,
  count: PropTypes.number.isRequired,
};

const StatusCounter = ({ className, count }) => {
  const classes = classNames({
    'status-counter': true,
    [className]: !!className,
  });

  return (
    <span className={classes} data-testid="status-counter">
      {count < 10 ? (
        count
      ) : (
        <>
          9<span className="counter-plus">+</span>
        </>
      )}
    </span>
  );
};

StatusCounter.propTypes = propTypes;

export default StatusCounter;
